var Assets = {};

export default Assets;
